import { render, staticRenderFns } from "./m-address-blue-card.vue?vue&type=template&id=d454069a&scoped=true&"
import script from "./m-address-blue-card.vue?vue&type=script&lang=ts&"
export * from "./m-address-blue-card.vue?vue&type=script&lang=ts&"
import style0 from "./m-address-blue-card.vue?vue&type=style&index=0&id=d454069a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d454069a",
  null
  
)

export default component.exports